import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: {},
    missing: (locale, key) => {
        console.warn('Missing translation: ' + key);
    }
});

export default i18n;

export const i18nSetup = router => {
    let i18nSetupComplete = false;
    router.beforeEach((to, from, next) => {
        if (!i18nSetupComplete) {
            i18nSetupComplete = true;
            fetch(process.env.VUE_APP_I18N_REMOTE_SOURCE)
                .then(response => response.json())
                .then(messages => {
                    console.log('received');
                    Object.keys(messages).forEach(k => messages[k] = decodeHtml(messages[k]));
                    i18n.setLocaleMessage(process.env.VUE_APP_I18N_LOCALE, messages);
                    next();
                })
                .catch(err => {
                    console.log('err');
                    console.log(err);
                    next();
                });
        } else {
            next();
        }
    });
};

const decodeHtml = html => {
    let txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}
